import React from "react";
import {Button, Row, Col, Container, Navbar, Nav, NavDropdown} from "react-bootstrap";
import marcel from './../../images/marcel.png';
import top from './../../images/top.webp';
import {getFirmaLink} from "../../GlobalServices";

const Header = () => {

    const renderLogo = () => {
        switch (getFirmaLink()) {
            case 'MARCEL' : return marcel
            default : return top
        }
    }

    return(
        <Navbar expand="lg" className="bg-body-tertiary header">
            <Container>
                <Navbar.Brand href="/">
                    <img
                        alt=""
                        src={renderLogo()}
                        // width="30"
                        height="30"
                        style={{marginRight: '15px'}}
                        className="d-inline-block align-top"
                    />
                    Sygnalista TOP
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse className="justify-content-end">
                    <Nav className="justify-content-end">
                        <Nav.Link href="/noweZgloszenie">Zgłoś naruszenie</Nav.Link>
                        <Nav.Link href="/mojeZgloszenie">Moje zgłoszenie</Nav.Link>
                        <Nav.Item><Button variant={'primary'} href={'/login'}>Zaloguj</Button></Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Header;
